import { TFunction } from 'i18next';
import { NavigateFunction } from 'react-router-dom';

/**
 * Translates an error message if it's a translation key, otherwise returns it as-is
 * @param error The error object or message
 * @param t The translation function from useTranslation
 * @returns The translated error message
 */
export function translateError(error: any, t: TFunction): string {
  const message = error?.message || error?.error || String(error);
  
  // Check if the message looks like a translation key (e.g., "validation.invalidEmailFormat")
  if (message && typeof message === 'string' && message.includes('.')) {
    // Try to translate it
    const translated = t(message);
    
    // If translation returned the same key, it means the key doesn't exist
    // In that case, return the original message
    if (translated !== message) {
      return translated;
    }
  }
  
  return message;
}

/**
 * Checks if an error is an unauthorized error and handles redirect to login
 * @param error The error object
 * @param navigate React Router navigate function
 * @param userType 'doctor' or 'parent'
 * @returns true if this was an unauthorized error (and redirect was triggered), false otherwise
 */
export function handleUnauthorizedError(
  error: any,
  navigate: NavigateFunction,
  userType: 'doctor' | 'parent'
): boolean {
  const message = error?.message || error?.error || String(error);
  
  if (message === 'Unauthorized' || message.toLowerCase().includes('unauthorized')) {
    // Clear auth state
    localStorage.removeItem('auth_token');
    localStorage.removeItem('isAuthenticated');
    
    // Redirect to appropriate login page
    const loginPath = userType === 'doctor' ? '/doctor/login' : '/parent/login';
    navigate(loginPath);
    
    return true;
  }
  
  return false;
}
